import { ShareResponse, ShareSettings } from '../models/object.models';
import {
  ContentFilters,
  DashboardPage,
  ExportSchedule,
  OutputSettingsType,
  Period,
} from '../models/core.models';
import { createAction, props } from '@ngrx/store';

import { NomExportTransportTypes } from '../constants';

/**
 * Pure broadcasts (no effects behind them): dispatched after the save/delete
 * mutations resolve, so the reducer keeps `exportSchedulesCount` - the number the
 * feed/dashboard badges read - in step. The list itself is a query.
 */
export const createExportScheduleSuccess = createAction(
  '[Core] Create Export Schedule Success',
  props<{ exportSchedule: ExportSchedule }>(),
);

export const deleteExportScheduleSuccess = createAction(
  '[Core] Delete Export Schedule Success',
  props<{ exportScheduleId: string }>(),
);

export const toggleObjectViewConfigOption = createAction(
  '[Core] Toggle Object View Config Option',
  props<{ optionName: string }>(),
);

export const toggleObjectViewConfigOptionSuccess = createAction(
  '[Core] Toggle Object View Config Option Success',
);

export const toggleObjectViewConfigOptionFail = createAction(
  '[Core] Toggle Object View Config Option Fail',
  props<{ error: string }>(),
);

export const share = createAction(
  '[Data Object] Share',
  props<{
    exportTransportId: NomExportTransportTypes;
    objectId: string;
    objectClassId: number;
    postIds: string[];
    contentFilters: ContentFilters;
    settings: ShareSettings;
    shareParams: any;
  }>(),
);

export const shareSuccess = createAction(
  '[Data Object] Share Success',
  props<{ response: ShareResponse }>(),
);

export const shareFailure = createAction(
  '[Data Object] Share Failure',
  props<{ error: any }>(),
);

export const shareCancelled = createAction(
  '[ExportForm] Share Cancelled',
  props<{ objectId: string }>(),
);

export const saveObjectOutputSettingsStateSuccess = createAction(
  '[Object] Save Feed Output Settings State Success',
  props<{
    objectId: string;
    objectClassId: number;
    settingsType: OutputSettingsType;
    settings: any;
  }>(),
);

export const updateObjectViewProperties = createAction(
  '[Object] Update Object View Properties',
  props<{
    viewProperties: {
      widget_display_attached_pivots?: boolean;
      widget_display_attached_filters?: boolean;
      widget_display_attached_data_sources?: boolean;
      post_sentiment_algorithm_id?: number[];
      show_advanced_quick_search?: boolean;
    };
  }>(),
);

// ! Multi-Page Dashboard actions - Start
// * `DashboardPagePersistenceService` runs the requests and dispatches the
// * `…Success` broadcasts below. `updateDashboardPagePeriod` is a pure client
// * action whose reducer handler is the optimistic period write.
export const createDashboardPageSuccess = createAction(
  '[Object] Create Dashboard Page Success',
  props<{ page: DashboardPage }>(),
);

export const deleteDashboardPageSuccess = createAction(
  '[Object] Delete Dashboard Page Success',
  props<{
    pages: DashboardPage[];
    deletedPageId: number;
    originalPages: DashboardPage[];
  }>(),
);

export const updateDashboardPageSuccess = createAction(
  '[Object] Update Dashboard Page Success',
  props<{ page: DashboardPage }>(),
);

export const reorderDashboardPagesSuccess = createAction(
  '[Object] Reorder Dashboard Pages Success',
  props<{ pages: DashboardPage[] }>(),
);

export const reorderDashboardPagesFail = createAction(
  '[Object] Reorder Dashboard Pages Fail',
  props<{
    error: string;
    rollbackPages: DashboardPage[];
  }>(),
);

export const selectDashboardPage = createAction(
  '[Object] Select Dashboard Page',
  props<{ pageId: number }>(),
);

export const updateDashboardPagePeriod = createAction(
  '[Object] Update Page Period',
  props<{ pageId: number; period: Period }>(),
);

// * Dashboard Page Multi-Select actions - Start
export const setDashboardPagesSelection = createAction(
  '[Dashboard] Set Selected Dashboard Pages',
  props<{ pageIds: number[] }>(),
);

export const toggleDashboardPageSelection = createAction(
  '[Dashboard] Toggle Dashboard Page Selection',
  props<{ pageId: number }>(),
);

export const clearDashboardPageSelection = createAction(
  '[Dashboard] Clear Dashboard Page Selection',
);

// * Dashboard Page Multi-Select actions - End

// ! Multi-Page Dashboard actions - End
